/// <reference path="../../../../../typings/index.d.ts" />
///<reference path="../../../components/models/meevo.model.custom.ts"/>
///<reference path="../../../components/baseClasses/guid.ts"/>
///<reference path="../../../components/models/meevo.dtos.d.ts"/>

module Meevo.Plugins.DocsAndForms {


    import ISelectItem = Meevo.Model.ISelectItem;
    export type SystemTagsTypes =
        | 'TextBox'
        | 'Notification'
        | 'RatingsNotifications'
        | 'Date'
        | 'BirthDay'
        | 'CheckBox'
        | 'Select'
        | 'Label'
        | 'ViewImage'
        | 'Referred'
        | 'CountryPhone'
        ;

    export interface ISystemTag {
        type: SystemTagsTypes;
        key: string;
        readableKey: string;
        label: string;
        selected?: boolean;
        required?: boolean;
        readOnly?: boolean;
        disable?: boolean;
        requiredEditable?: boolean;
        readOnlyEditable?: boolean;
        data?: _.Dictionary<any>;
        dataStringify?: string;
    }

    export interface ISystemTagsModelOptions {
        required?: boolean;
        requiredEditable?: boolean;
        readOnly?: boolean;
        readOnlyEditable?: boolean;
        communication?: number;
        selected?: boolean;
        disable?: boolean;
        imgUrl?: string;
    }

    export interface ISystemTagImageSize {
        width: number;
        height: number;
    }

    export interface ISystemTagModel extends ISystemTag {
        update(tag: ISystemTag): void;
    }

    export abstract class SystemTagModelBase implements ISystemTagModel {

        protected _required: boolean;
        protected _readOnly: boolean;

        public abstract type: SystemTagsTypes;

        public readableKey: string;
        public requiredEditable: boolean;
        public readOnlyEditable: boolean;
        public selected: boolean;
        public disable: boolean;

        get readOnlyDisabled() {
            return !this.readOnlyEditable || this.required;
        }

        get required(): boolean {
            return this._required;
        }

        set required(value: boolean) {
            if (value) {
                this.readOnly = false;
                this.selected = true;
            }

            this._required = value;
        }

        get readOnly(): boolean {
            return this._readOnly;
        }

        set readOnly(value: boolean) {
            if (value) {
                this.selected = true;
            }

            this._readOnly = value;
        }

        constructor(public key: string, public label: string, options: ISystemTagsModelOptions = {}) {
            this.readableKey = key
                .replace(/({|}| )/g, '');
            const { required, readOnly, requiredEditable, readOnlyEditable, selected, disable } = options;

            this.required = typeof required === 'undefined' ? false : required;
            this.readOnly = typeof readOnly === 'undefined' ? false : readOnly;
            this.requiredEditable = typeof requiredEditable === 'undefined' ? true : requiredEditable;
            this.readOnlyEditable = typeof readOnlyEditable === 'undefined' ? true : readOnlyEditable;
            this.selected = typeof selected === 'undefined' ? false : selected;
            this.disable = typeof disable === 'undefined' ? false : disable;
        }

        public update(tag: ISystemTag): void {
            Object.assign(this, tag);
        }
    }

    export class SystemTagDateModel extends SystemTagModelBase implements ISystemTag {
        public type: SystemTagsTypes = 'Date';
        public value: string;

        constructor(key: string, label: string, value: string, options: ISystemTagsModelOptions = {}) {
            super(key, label);

            const { required, readOnly, requiredEditable, readOnlyEditable} = options;
            this.required = typeof required === 'undefined' ? false : required;
            this.readOnly = typeof readOnly === 'undefined' ? false : readOnly;
            this.requiredEditable = typeof requiredEditable === 'undefined' ? true : requiredEditable;
            this.readOnlyEditable = typeof readOnlyEditable === 'undefined' ? true : readOnlyEditable;

            this.value = value;
        }
    }

    export class SystemTagBirthDatModel extends SystemTagModelBase implements ISystemTag {
        public type: SystemTagsTypes = 'BirthDay';

        public monthKey: string;
        public dayKey: string;
        public yearKey: string;

        constructor(entity: string, label: string, options: ISystemTagsModelOptions = {}) {
            super(`{${entity}.BirthDay}`, label, options);

            this.monthKey = `{${entity}.BirthMonth}`;
            this.dayKey = `{${entity}.BirthDay}`;
            this.yearKey = `{${entity}.BirthYear}`;
        }
    }

    export class SystemTagNotificationModel extends SystemTagModelBase implements ISystemTag {
        public type: SystemTagsTypes = 'Notification';

        public dataStringify: string;
        public daysKey: string;
        public emailKey: string;
        public smsKey: string;

        constructor(key, label, data: { communication: number; }, public hasDays: boolean = false) {
            super(key, label);

            this.dataStringify = encodeURI(JSON.stringify(data));
            this.daysKey = `{${this.readableKey}.SendDaysBefore}`;
            this.emailKey = `{${this.readableKey}.IsEmailEnabled}`;
            this.smsKey = `{${this.readableKey}.IsSMSEnabled}`;
        }
    }

    export class SystemTagTextBoxModel extends SystemTagModelBase implements ISystemTag {
        public type: SystemTagsTypes = 'TextBox';
        public inputType: string = 'text';
    }

    export class SystemTagFirstLastNamesModel extends SystemTagTextBoxModel {
        get readOnlyDisabled() {
            return false;
        }

        get required(): boolean {
            return this._required;
        }

        set required(value: boolean) {
            if (value) {
                this.selected = true;
            }

            this._readOnly = !value;
            this._required = value;
        }

        get readOnly(): boolean {
            return this._readOnly;
        }

        set readOnly(value: boolean) {
            if (value) {
                this.selected = true;
            }

            this._required = !value;
            this._readOnly = value;
        }
    }

    export class SystemTagEmailModel extends SystemTagTextBoxModel implements ISystemTag {
        public type: SystemTagsTypes = 'TextBox';
        public inputType: string = 'email';
    }

    export class SystemTagLabelModel extends SystemTagModelBase implements ISystemTag {
        public type: SystemTagsTypes = 'Label';
        public placeholder: string;

        constructor(key, label, placeholder?: string) {
            super(key, label);

            this.readOnly = true;
            this.requiredEditable = false;
            this.readOnlyEditable = false;
            this.placeholder = placeholder || label;
        }
    }

    export class SystemTagCheckBoxModel extends SystemTagModelBase implements ISystemTag {
        public type: SystemTagsTypes = 'CheckBox';
    }

    export class SystemTagSelectModel extends SystemTagModelBase implements ISystemTag {
        public type: SystemTagsTypes = 'Select';

        public valueKey: string;

        public rows: ISelectItem<string | number>[];

        constructor(key: string, valueKey: string, label: string, rows: ISelectItem<string | number>[], options: ISystemTagsModelOptions = {}) {
            super(key, label, options);

            this.valueKey = valueKey;
            this.rows = _.clone(rows);

            if (!this.required) {
                this.rows.unshift({ value: '', label: '' });
            }

        }
    }

    export class SystemTagReferredModel extends SystemTagSelectModel {
        public type: SystemTagsTypes = 'Referred';
    }

    export class SystemTagViewImageModel extends SystemTagModelBase implements ISystemTag {
        public type: SystemTagsTypes = 'ViewImage';
        public width: number;
        public height: number;
        public imgUrl: string;

        constructor(public key: string, public label: string, imageSize: ISystemTagImageSize, options?: ISystemTagsModelOptions) {
            super(key, label, options);
            this.width = imageSize.width;
            this.height = imageSize.height;
            this.imgUrl = options.imgUrl || `${window.location.origin}/assets/images/photo_not_available.svg`;
        }
    }

    interface ISystemTagCountryPhoneModelOptions extends ISystemTagsModelOptions {
        countryPhoneCodeKey: string;
        countryCodeKey: string;
    }

    export class SystemTagCountryPhoneModel extends SystemTagModelBase {
        public type: SystemTagsTypes = 'CountryPhone';
        public countryPhoneCodeKey: string;
        public countryCodeKeyReadable: string;
        public countryCodeKey: string;

        constructor(key: string, label: string, options: ISystemTagCountryPhoneModelOptions) {
            super(key, label, options);

            this.countryPhoneCodeKey = options.countryPhoneCodeKey;
            this.countryCodeKey = options.countryCodeKey;
            this.countryCodeKeyReadable = options.countryPhoneCodeKey.replace(/({|}| )/g, '');
        }
    }

}
